export const RESET_GOALS = "RESET_GOALS";
export const RESET_GOAL = "RESET_GOAL";
export const RESET_ERROR = "GOALS_RESET_ERROR";

export const GET_GOALS = "GET_GOALS";
export const SET_GOALS = "SET_GOALS";

export const API_ERROR = "GOALS_API_ERROR";

export const GET_GOAL = "GET_GOAL";
export const SET_GOAL = "SET_GOAL";

export const EDIT_GOAL = "EDIT_GOAL";
export const EDIT_GOAL_SUCCESS = "EDIT_GOAL_SUCCESS";

export const CREATE_GOAL = "CREATE_GOAL";
export const CREATE_GOAL_SUCCESS = "CREATE_GOAL_SUCCESS";

export const DELETE_GOAL = "DELETE_GOAL";
export const DELETE_GOAL_SUCCESS = "DELETE_GOAL_SUCCESS";
